import React from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet';
import {
  PersistGate,
} from 'redux-persist/integration/react';
import {
  Provider,
} from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime'; // eslint-disable-line import/no-extraneous-dependencies

import 'bootstrap/dist/css/bootstrap.min.css';

import logger from './core/logger';
import configuredStore from './core/configureReduxStore';
import Routes from './Routes';

import ErrorBoundary from './application/shared/components/errorBoundary';
import { setNewApplicationVersionAvailable } from './application/actions';

const registerOfflinePlugin = () => {
  if (ENABLE_SERVICE_WORKERS === true) {
    OfflinePluginRuntime.install({
      onUpdateReady: () => {
        OfflinePluginRuntime.applyUpdate();
      },
      onUpdated: () => {
        configuredStore.store.dispatch(setNewApplicationVersionAvailable(true));
      },
    });

    logger.info('Service Workers have been installed.');
  }
};

async function renderApplication({ store, persistor }) {
  const container = document.getElementById('application-root');
  const root = createRoot(container);

  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <div className="application">
            <Helmet>
              <title>{window.env.PAGE_TITLE}</title>
            </Helmet>
            <ErrorBoundary>
              <Routes />
            </ErrorBoundary>
          </div>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  );
}

async function initializeApplication() {
  logger.info('Application\'s initialization has been started.');

  const currentReduxStoreVersion = STORE_VERSION;
  const restoredReduxStoreVersion = localStorage.getItem('reduxStore:UMWM:version');
  if (!restoredReduxStoreVersion) {
    localStorage.setItem('reduxStore:UMWM:version', currentReduxStoreVersion);
    logger.info('Application\'s reduxStore version has been set.');
  }
  if (restoredReduxStoreVersion && currentReduxStoreVersion !== restoredReduxStoreVersion) {
    localStorage.removeItem('reduxStore:UMWM');
    logger.info('Application\'s localStorage has been cleared (new reduxStore version).');

    localStorage.setItem('reduxStore:UMWM:version', currentReduxStoreVersion);
    logger.info('Application\'s reduxStore version has been updated.');
  }

  renderApplication(configuredStore);
  logger.info('Application\'s reduxStore has been configured.');

  registerOfflinePlugin();
}

initializeApplication();
